import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { red, green, yellow } from '@material-ui/core/colors';

import { RiAlarmWarningFill } from "react-icons/ri";

import {
  Box,
  Link,
  makeStyles,
  CardHeader,
  Grid,
  Card,
  colors,
  Avatar,
  Icon,
  Typography
} from '@material-ui/core';

import { GoTasklist } from "react-icons/go";

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  avatar1: {
    background: green[600]
  },
  avatar2: {
    background: yellow[600]
  },
  avatar3: {
    background: red[600]
  }
}));

var item = {
  numero: null,
  slaPrimeiroAtendimento: null,
  statusEmpresa: { nome: null },
  unidade: { codigo: null }
}

const Taskbar = ({ item, slas, title }) => {

  const classes = useStyles();

  const getStatusRealizacao = (item) => {
    if (item.conclusionStatus == 3) {
      return classes.avatar1
    } else if (item && item.ocorrencia && (item.ocorrencia.servicoExecutado || item.ocorrencia.dataConclusaoAtendimento || item.ocorrencia.dataInicioAtendimento || item.ocorrencia.horasExecucaoServico)) {
      return classes.avatar2
    } else {
      return classes.avatar3
    }
  }

  return (
    <Fragment>
      <Grid container
        direction="row"
        justifyContent="flex-start"
        alignItems="baseline"
        spacing={2}
      >
        <Grid item>
          <Avatar className={getStatusRealizacao(item)} >
            <Icon component={RiAlarmWarningFill}></Icon>
          </Avatar>
        </Grid>
        <Grid item>
          <Typography
            component="span"
            variant="h4"
            color="textPrimary">
            <b>{(title) ? title : item.task + ' - ' + item.taskName}</b>
          </Typography>
        </Grid>
      </Grid>
    </Fragment>
  );
};

Taskbar.propTypes = {
  className: PropTypes.string
};

export default Taskbar;
